import {
  SYSTEM_ID_ENERGY_DEMO,
  SYSTEM_ID_ENERGY_DEMO_UK,
  SYSTEM_ID_ENERGY_US_DEMO_1,
  SYSTEM_ID_ENERGY_US_DEMO_2,
  SYSTEM_ID_ENERGY_US_DEMO_3,
  SYSTEM_ID_PERCIVAL,
} from './system-ids';

/**
 * Demo systems are pinned to a fixed end date so every page shows the same data
 * on every visit. Membership of this map is what marks a system as a demo system.
 */
export const DEMO_SYSTEM_DEFAULT_END_DATES: Record<string, Date> = {
  [SYSTEM_ID_PERCIVAL]: new Date('2022-10-20T00:00:00Z'),
  [SYSTEM_ID_ENERGY_DEMO]: new Date('2022-09-01T00:00:00Z'),
  [SYSTEM_ID_ENERGY_DEMO_UK]: new Date('2023-12-01T00:00:00Z'),
  [SYSTEM_ID_ENERGY_US_DEMO_1]: new Date('2024-04-01T00:00:00Z'),
  [SYSTEM_ID_ENERGY_US_DEMO_2]: new Date('2024-10-01T00:00:00Z'),
  [SYSTEM_ID_ENERGY_US_DEMO_3]: new Date('2024-04-09T00:00:00Z'),
};
